import { apiEndpoint } from "../utils/env";

async function parseBodyOrThrow(res) {
  const txt = await res.text();
  let body = null;
  try { body = txt ? JSON.parse(txt) : null; } catch { body = txt; }
  if (!res.ok) {
    const msg = (body && body.message) || (typeof body === "string" ? body : res.statusText);
    const err = new Error(msg || `Request failed: ${res.status}`);
    err.code = (body && body.code) || null;
    err.status = res.status;
    err.details = body;
    throw err;
  }
  return body;
}

function authHeaders(token, extra = {}) {
  const h = { ...extra };
  if (token) h["Authorization"] = `Bearer ${token}`;
  return h;
}

export async function listUploadSessions(token, { status, take = 50 } = {}) {
  const params = new URLSearchParams();
  if (status) params.set("status", status);
  if (take) params.set("take", String(take));
  const url = apiEndpoint(`/api/upload-sessions?${params.toString()}`);
  const res = await fetch(url, { headers: authHeaders(token) });
  return parseBodyOrThrow(res);
}

export async function getUploadSession(token, sessionGuid) {
  const url = apiEndpoint(`/api/upload-sessions/${encodeURIComponent(sessionGuid)}`);
  const res = await fetch(url, { headers: authHeaders(token) });
  return parseBodyOrThrow(res);
}

export async function createUploadSession(token, request) {
  const url = apiEndpoint("/api/upload-sessions");
  const res = await fetch(url, {
    method: "POST",
    headers: authHeaders(token, { "Content-Type": "application/json" }),
    body: JSON.stringify(request || {}),
  });
  return parseBodyOrThrow(res);
}

export async function uploadSessionFiles(token, sessionGuid, files) {
  const url = apiEndpoint(`/api/upload-sessions/${encodeURIComponent(sessionGuid)}/files`);
  const fd = new FormData();
  for (const f of files) fd.append("files", f, f.name);
  const res = await fetch(url, {
    method: "POST",
    headers: authHeaders(token),
    body: fd,
  });
  return parseBodyOrThrow(res);
}

export async function registerUploadSession(token, sessionGuid, request) {
  const url = apiEndpoint(`/api/upload-sessions/${encodeURIComponent(sessionGuid)}/register`);
  const res = await fetch(url, {
    method: "POST",
    headers: authHeaders(token, { "Content-Type": "application/json" }),
    body: JSON.stringify(request || {}),
  });
  return parseBodyOrThrow(res);
}

export async function cancelUploadSession(token, sessionGuid) {
  const url = apiEndpoint(`/api/upload-sessions/${encodeURIComponent(sessionGuid)}`);
  const res = await fetch(url, {
    method: "DELETE",
    headers: authHeaders(token),
  });
  if (res.status === 204) return null;
  return parseBodyOrThrow(res);
}
